import * as React from 'react';
import { ModalWindow } from '../../../../modal';
import styles from './styles.module.css';
import { GroupedSelectMobileOptions } from '../GroupedSelectMobileOptions';
import { generateDataTestId } from '../../../../internal/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function GroupedSelectMobileModal(props) {
  const {
    open,
    onClose,
    groups,
    onChange,
    value,
    title,
    dataTestId
  } = props;
  const handleChange = React.useCallback(value => {
    if (onChange) {
      onChange(value);
    }
    onClose();
  }, [onChange, onClose]);
  return /*#__PURE__*/_jsx(ModalWindow, {
    fixed: true,
    open: open,
    onClose: onClose,
    title: title,
    width: 648,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['list'],
      role: "listbox",
      "data-testid": generateDataTestId(dataTestId, ['items']),
      children: groups.map(group => {
        const {
          key,
          label,
          leftAdornment,
          options,
          dataTestId
        } = group;
        const defaultTestId = generateDataTestId('group', [key]);
        const testId = dataTestId || defaultTestId;
        return /*#__PURE__*/_jsxs("div", {
          className: styles['group-wrapper'],
          "data-testid": testId,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles['group'],
            children: /*#__PURE__*/_jsxs("div", {
              className: styles['group-label'],
              children: [!!leftAdornment && /*#__PURE__*/_jsx("div", {
                className: styles['icon'],
                children: leftAdornment
              }), /*#__PURE__*/_jsx("div", {
                className: styles['label'],
                children: label
              })]
            })
          }), /*#__PURE__*/_jsx(GroupedSelectMobileOptions, {
            indented: !!leftAdornment,
            options: options,
            value: value,
            onChange: handleChange
          })]
        }, key);
      })
    })
  });
}